import axios from "axios";

export const ExamResultApi = async (questionType, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/exam/result?";

    const endpoint = `${BASED_URL}${path}questionType=${questionType}&token=${token}`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export default ExamResultApi;
